import React from 'react';

const DiceSvg = ({ value, type = 'classic' }) => {
  const getDots = (val) => {
    const dotPositions = {
      1: [[50, 50]],
      2: [[25, 25], [75, 75]],
      3: [[25, 25], [50, 50], [75, 75]],
      4: [[25, 25], [75, 25], [25, 75], [75, 75]],
      5: [[25, 25], [75, 25], [50, 50], [25, 75], [75, 75]],
      6: [[25, 25], [75, 25], [25, 50], [75, 50], [25, 75], [75, 75]]
    };
    return dotPositions[val] || [];
  };

  const getClassicStyles = () => ({
    dot: {
      fill: '#333',
      filter: 'drop-shadow(1px 1px 2px rgba(0,0,0,0.3))'
    }
  });

  const getModernStyles = () => ({
    dot: {
      fill: 'url(#modernGradient)',
      filter: 'drop-shadow(1px 1px 2px rgba(0,0,0,0.5))'
    }
  });

  const getNeonStyles = () => ({
    dot: {
      fill: '#00ffff',
      filter: 'drop-shadow(0px 0px 4px #00ffff) drop-shadow(0px 0px 8px #00ffff)',
      opacity: 0.9
    }
  });

  const getStyles = () => {
    switch (type) {
      case 'modern': return getModernStyles();
      case 'neon': return getNeonStyles();
      default: return getClassicStyles();
    }
  };

  const styles = getStyles();
  const dots = getDots(value);

  return (
    <svg 
      width="100%" 
      height="100%" 
      viewBox="0 0 100 100" 
      style={{ display: 'block' }}
    >
      <defs>
        {type === 'modern' && (
          <linearGradient id="modernGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#ecf0f1" />
            <stop offset="100%" stopColor="#bdc3c7" />
          </linearGradient>
        )}
        {type === 'neon' && (
          <>
            <filter id="neonGlow">
              <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
              <feMerge> 
                <feMergeNode in="coloredBlur"/>
                <feMergeNode in="SourceGraphic"/>
              </feMerge>
            </filter>
            <animate 
              attributeName="opacity" 
              values="0.7;1;0.7" 
              dur="2s" 
              repeatCount="indefinite"
            />
          </>
        )}
      </defs>
      
      {dots.map((dot, index) => (
        <circle
          key={index}
          cx={dot[0]}
          cy={dot[1]}
          r={type === 'neon' ? '6' : '8'}
          style={styles.dot}
          filter={type === 'neon' ? 'url(#neonGlow)' : undefined}
        >
          {type === 'neon' && (
            <animate 
              attributeName="r" 
              values="6;8;6" 
              dur="1.5s" 
              repeatCount="indefinite"
            />
          )}
        </circle>
      ))}
    </svg>
  );
};

export default DiceSvg;